import registrationStep from "../../registrationStep";
import ConfirmPhonePage from "./ConfirmPhonePage";

export default registrationStep(
  ConfirmPhonePage,
  "confirm-phone",
  "contact-info"
);



// WEBPACK FOOTER //
// ./src/registration/components/ConfirmPhone/index.js